import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getCall } from './api-calls/apicalls.service';
import { HeadersService } from './api-calls/headers.service';
import { DealDocument } from '@models/models';

@Injectable({
    providedIn: 'root',
})
export class DocumentService extends HeadersService {
    constructor(public _http: HttpClient) {
        super(_http);
    }

    getDocumentCategories() {
        const url = getCall('settings', null, {
            key: 'document_categories',
        });

        return this._http.get(url, this.getHeaders());
    }

    saveDocuments(data: any) {
        const url = getCall('documentation', null, {
            access: localStorage.getItem('user-access'),
        });

        return this._http.post(url, data, this.getHeaderWOCT());
    }

    deleteDocument(documentID: string) {
        const url = getCall('documentation', documentID, {
            access: localStorage.getItem('user-access'),
        });

        return this._http.delete(url, this.getHeaderWOCT());
    }

    updateDocument(documentID: string, data: any) {
        const url = getCall('documentation', documentID, {
            access: localStorage.getItem('user-access'),
        });

        return this._http.put(url, data, this.getHeaderWOCT());
    }
}
